import { SuccessOrderStepBase } from '@/pages/CheckoutPage/steps/SuccessOrderStep'

export const PublicCheckoutSuccessStep = () => {
  return <SuccessOrderStepBase />
}
